/*eslint-disable */

import Multiselect from 'vue-multiselect'
import {
  bus
} from '@/main';
import toast from '@/services/toast';

export default {
  name: 'data-shared-popup',
  components: {
    Multiselect
  },
  props: ['sharedDatasetInfo'],
  data() {
    return {
      submitted: false,
      userList: null,
      userListResults: [],
      options: [],
      name: '',
      sentUserData: [],
      users: [],
      sharedDatasetId: '',
    }
  },
  computed: {

  },
  mounted() {
    this.getAllUserListMethod()
    this.name = this.sharedDatasetInfo.header
    this.sharedDatasetId = this.sharedDatasetInfo.id
  },
  methods: {
    customLabel ({ email, first_name, last_name }) {
      return `${first_name} ${last_name} - ${email}`
    },
    getAllUserListMethod() {
      this.$store.dispatch('isConditionalListOfAllUsersFun').then((res) => {
        this.userList = res.data.data
        if (this.userList) {
          this.userListResults = this.userList
          for (var i = 0; i < this.userListResults.length; i++) {
            this.options.push({
              first_name: this.userListResults[i].first_name,
              last_name: this.userListResults[i].last_name,
              email: this.userListResults[i].email,
              id: this.userListResults[i].id
            })
          }
        }
      }).catch((err) => {})
    },
    sharedNotesMethod() {
      this.sentUserData = []
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true
          for (var i = 0; i < this.users.length; i++) {
            this.sentUserData.push(this.users[i].id)
          }
          var data = {
            algo_data: this.sharedDatasetId,
            user: this.sentUserData,
            write_access:this.write_access
          }
          this.$store.dispatch('shareDatasetAction', data)
            .then((res) => {
              toast.success("Request processed successfully.");
              this.submitted = false
              this.sharedDatasetPopupClosedMethod();
            }).catch((err) => {
              toast.error(err.data.message || "Request failed.");
              this.submitted = false
            })
          return;
        }
      })
    },
    sharedDatasetPopupClosedMethod() {
      document.body.classList.remove('body_right_scroll_remove')
      bus.$emit('sharedDatasetStateBus', false);
    }
  }
}